import { createSlice } from "@reduxjs/toolkit";
import {
  deleteConversation,
  fetchConversations,
  fetchMessages,
  fetchUnreadByUser,
  fetchUnreadCount,
  markMessagesAsRead,
  sendMessage,
} from "./operations.js";

const initialState = {
  messages: [],
  isLoading: false,
  isSending: false,
  error: null,
  conversations: [],
  onlineUsers: [],
  unreadCount: 0,
  activeChatUserId: null,
  unreadByUser: {},
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    clearChat(state) {
      state.messages = [];
      state.error = null;
      state.isLoading = false;
      state.isSending = false;
    },
    setOnlineUsers: (state, action) => {
      state.onlineUsers = action.payload;
    },
    addMessage(state, action) {
      state.messages.push(action.payload);
    },
    setActiveChatUserId(state, action) {
      state.activeChatUserId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMessages.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMessages.fulfilled, (state, action) => {
        state.isLoading = false;
        state.messages = action.payload;
      })
      .addCase(fetchMessages.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(sendMessage.pending, (state) => {
        state.isSending = true;
        state.error = null;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.isSending = false;
        state.messages.push(action.payload);
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.isSending = false;
        state.error = action.payload;
      })
      .addCase(fetchConversations.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchConversations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.conversations = action.payload;
      })
      .addCase(fetchConversations.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchUnreadCount.fulfilled, (state, action) => {
        state.unreadCount = action.payload;
      })
      .addCase(fetchUnreadCount.rejected, (state, action) => {
        state.error = action.payload;
      })
      // .addCase(markMessagesAsRead.fulfilled, (state) => {
      //   state.unreadCount = 0; // сброс счётчика
      // })

      .addCase(markMessagesAsRead.fulfilled, (state, action) => {
        const { receiverId } = action.payload;

        // Обнуляем только у конкретного собеседника
        if (state.unreadByUser[receiverId]) {
          state.unreadByUser[receiverId] = 0;
        }

        // Пересчитываем глобальный счётчик
        state.unreadCount = Object.values(state.unreadByUser).reduce(
          (a, b) => a + b,
          0
        );
      })

      .addCase(fetchUnreadByUser.fulfilled, (state, action) => {
        state.unreadByUser = action.payload;
      })
      .addCase(deleteConversation.fulfilled, (state, action) => {
        state.conversations = state.conversations.filter(
          (user) => user.id !== action.payload.userId
        );
      });
  },
});

export const { clearChat, setOnlineUsers, addMessage, setActiveChatUserId } =
  chatSlice.actions;
export default chatSlice.reducer;
